module.exports = __webpack_public_path__ + "img/v-pay@2x.571fdc86.png";